import Button from '../../components/form-control/Button';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { getAdmins, setRelationshipManager } from '../../api/requests';
import SelectDropdown, {
  ISelectDropdownItem
} from '../../components/form-control/SelectDropdown';
import { showToast } from '../../utils/miscFunctions';

export interface IAssignRelationshipManager {
  teamId: string;
  managerId: string;
}

const AssignRelationshipManager = ({
  onProceed,
  onClose,
  teamID
}: {
  onProceed: () => void;
  onClose: () => void;
  teamID: string;
}) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [admins, setAdmins] = useState<any>([]);

  useEffect(() => {
    getAllAdmins();
  }, []);

  const getAllAdmins = (page = 0) => {
    setLoading(true);
    getAdmins()
      .then((response: any) => {
        const _admins = response?.data?.data;
        setAdmins(_admins);
      })
      .catch((error: Error) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const submitHandler = (values: any) => {
    setSubmitting(true);
    const payload: IAssignRelationshipManager = {
      teamId: teamID,
      managerId: values.id
    };

    setRelationshipManager(payload)
      .then((response: any) => {
        showToast.success(response?.message ?? 'Member assigned to company successfully');
        onProceed();
      })
      .catch((error: any) => {
        showToast.error(error?.description);
      })
      .finally(() => setSubmitting(false));
  };
  return (
    <div className="bg-white rounded-xl dark:bg-darkBg">
      <div className="flex items-center justify-center mt-[26px]">
        <span className="text-center px-2 dark:text-darkBg-mainText">
          You are about to assign a relationship manager to this company.
        </span>
      </div>
      <div className="p-[1rem] w-full">
        <Formik
          initialValues={{
            id: ''
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={Yup.object({
            // email: Yup.string().email('Email provided invalid.').required('Email is requied.')
          })}
          onSubmit={(values) => {
            submitHandler(values);
          }}>
          {({ values, errors, handleSubmit, handleChange, setFieldValue, handleBlur, touched }) => (
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="">
                <SelectDropdown
                  label="Select Company Manager"
                  name="id"
                  list={admins?.map((admin: any) => (
                    {
                        name: `${admin.firstName} ${admin.lastName}`,
                        value: admin.id
                    }
                  ))}
                  listSelectedValue={values.id}
                  onChange={(val: ISelectDropdownItem | null) => {
                    setFieldValue('id', val);
                  }}
                  onBlur={handleBlur}
                  placeholder="Select Manager"
                  error={touched.id ? errors.id : undefined}
                  helperText={touched?.id ? errors.id : undefined}
                  required
                />
              </div>

               <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  type="button"
                  label="Cancel"
                  bgColor='secondary'
                  fullWidth
                  onClick={onClose}
                  loading={submitting}
                  disabled={submitting}
                />
                <Button
                  type="submit"
                  label="Submit"
                  bgColor='primary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AssignRelationshipManager;
